import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, finalize } from 'rxjs';
import { LoaderService } from '../service/loader.service';

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {
  private readonly ignoredRoutes: string[] = ['/auth/login', '/auth/register'];

  private readonly loaderService = inject(LoaderService);

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const isAuthRoute = this.ignoredRoutes.some((route) => req.url.includes(route));

    if (isAuthRoute) {
      return next.handle(req);
    }

    this.loaderService.showLoader();
    return next.handle(req).pipe(finalize(() => this.loaderService.hideLoader()));
  }
}
